import React from "react";

export function Logo({ size = 72, className = "", rounded = true }) {
  return (
    <div
      className={className}
      style={{ width: size, height: size, borderRadius: rounded ? 18 : 0, overflow: "hidden" }}
    >
      <img
        src="/wonderbean-logo-transparent.png?v=navy-20260909"
        alt="Wonderbean Coffee Co. logo"
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </div>
  );
}

export function Wordmark({ className = "", style = {} }) {
  return (
    <span className={`font-brand ${className}`} style={style}>
      BrewMate
    </span>
  );
}
